/**
 * Provider registry.
 *
 * Ordered list of AI provider adapters. The router tries them in this
 * order and uses the first one that returns a non-null answer.
 *
 * To add a future provider (OpenAI, Claude, DeepSeek, Qwen, Llama, a local
 * model, ...): create providers/yourProvider.js exporting the same shape
 * ({ name, ask(query) }) as groq.js, then add it to this array. Nothing
 * else in the router, the calculator engine, or the UI needs to change.
 */
import groq from "./groq";
import gemini from "./gemini";
import openrouter from "./openrouter";

export const PROVIDERS = [groq, gemini, openrouter];

export default PROVIDERS;
